import React, { useContext } from "react";
import { ThemeContext } from "../../../ThemeProvider";
import classes from "./Experience.module.css";

const Experience = ({
  toggleState,
  toggleNum,
  name,
  period,
  points,
  designation,
}) => {
  const { dark } = useContext(ThemeContext);

  const active__content__className = () => {
    if (toggleState === toggleNum && !dark) {
      return `${classes.content} ${classes.activeContent}`;
    } else if (toggleState === toggleNum && dark) {
      return `${classes.activeContent} ${classes.activeContent__dark}`;
    } else {
      return classes.content;
    }
  };

  return (
    <div className={active__content__className()}>
      <h3 className={classes.title}>
        {designation}{" "}
        <span className={dark ? classes.desig__dark : classes.desig}>
          @ {name}
        </span>
      </h3>
      <p>{period}</p>
      <ul>
        {points.map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>
    </div>
  );
};

export default Experience;
